import React from "react";
import "./styles.scss";

import { updateObject } from "../../utils/reducerUtils";
import { authCallback } from "../../utils/bankIdLogin";

import sendPin from "../../api/sendPin";
import initCustomLogin from "../../api/initCustomLogin";

import queryString from "query-string";
const parsedSearch = queryString.parse(window.top.location.search);
const key = parsedSearch.key;

const normalizePin = (s) =>
  (s ?? "").toString().replace(/\s+/g, "").trim().toUpperCase();

class CustomLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSendVerifcaiton: true,
      hasResendEmailwithPinCode: false,
      resendEmail: props.email || props.dispatchAddress || "",
      flowStatus: null,
      reqPin: props.pinCode,
      testUser: {
        firstName: null,
        lastName: null,
        email: props.email || props.dispatchAddress || "",
        key: key ?? null,
        pin: "",
        origin: "childScreening",
      },
      pinSentAt: null,
      resendCooldown: 45,
      pinError: false,
      _now: Date.now(),
    };
    this.pinRef = React.createRef();
  }

  componentDidMount() {
    const el = this.pinRef.current;
    if (el) el.focus();
    this._tick = setInterval(() => this.setState({ _now: Date.now() }), 1000);
  }
  componentWillUnmount() {
    clearInterval(this._tick);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.pinCode !== this.props.pinCode ||
      prevProps.email !== this.props.email ||
      prevProps.dispatchAddress !== this.props.dispatchAddress
    ) {
      const nextEmail =
        this.props.email || this.props.dispatchAddress || this.state.resendEmail;
      this.setState(
        (s) => ({
          reqPin: this.props.pinCode ?? s.reqPin,
          resendEmail: nextEmail,
          testUser: updateObject(s.testUser, { email: nextEmail }),
        }),
        () => this.pinRef.current?.focus()
      );
    }
  }

  remainingCooldown() {
    if (!this.state.pinSentAt) return 0;
    const elapsed = Math.floor((Date.now() - this.state.pinSentAt) / 1000);
    return Math.max(0, this.state.resendCooldown - elapsed);
  }

  handleUpdateTestUserEvent = (e) => {
    const { name, value = "" } = e.target;
    const val = name === "pin" ? normalizePin(value) : value;
    this.setState((s) => ({
      testUser: updateObject(s.testUser, { [name]: val }),
      pinError: name === "pin" ? false : s.pinError,
    }));
  };

  sendPinToUserEmailAddress = (email) => {
    if (!email) {
      this.setState({ flowStatus: "Keine Zieladresse gefunden." });
      return;
    }
    sendPin({ email, key, origin: "childScreening" })
      .then((res) => {
        this.setState(
          {
            hasResendEmailwithPinCode: true,
            hasSendVerifcaiton: true,
            reqPin: res.PIN,
            flowStatus: null,
            pinSentAt: Date.now(),
            pinError: false,
          },
          () => this.pinRef.current?.focus()
        );
      })
      .catch(() => {
        this.setState({
          flowStatus: "Fehler: Ungültiger Testcode oder E-Mail-Adresse.",
        });
      });
  };

  initCustomLogin = () => {
    const expected = normalizePin(this.state.reqPin ?? this.props.pinCode);
    const entered = normalizePin(this.state.testUser.pin);
	console.log('Entered ',entered);
	console.log('Expected ',expected);
    if (expected && entered && expected === entered) {
      this.setState({ pinError: false });
      initCustomLogin(this.state.testUser)
        .then((results) => {
          results.top = true;
          if (results?.action === "auth" && results?.result === "OK") {
            window.removeEventListener("message", authCallback);
            localStorage.setItem("authtoken-screening", results.authToken);
            window.top.location.href = `/test`;
          } else {
            this.setState({ flowStatus: "Anmeldung fehlgeschlagen." });
          }
        })
        .catch(() => {
          this.setState({ flowStatus: "Ungültiger Testcode." });
        });
    } else {
      this.setState({ flowStatus: "Falscher PIN-Code.", pinError: true });
    }
  };

  render() {
    const {
      hasResendEmailwithPinCode,
      flowStatus,
      testUser,
      pinError,
      resendEmail,
    } = this.state;

    const targetEmail =
      this.props.email || this.props.dispatchAddress || resendEmail;

    const secondsLeft = this.remainingCooldown();
    const canResend = secondsLeft === 0;
    const isErrorBanner = /Falsch|Ungültig|Fehler/i.test(flowStatus || "");

    return (
      <div className="lit-customLogin lit-card">
        <div className="lit-customLogin-wrapper">
          <div className="lit-customPin-form-wrapper">
            {hasResendEmailwithPinCode && targetEmail && (
              <div className="lit-alert lit-alert--success" role="status" aria-live="polite">
                <strong>PIN-Code ist unterwegs</strong> 📧. Wir haben ihn an{" "}
                <em>{targetEmail}</em> gesendet. Bitte prüfen Sie Ihren Posteingang
                (und ggf. den Spam-Ordner).
              </div>
            )}

            {flowStatus && (
              <div
                className={`lit-alert ${
                  isErrorBanner ? "lit-alert--error" : "lit-alert--info"
                }`}
                role="status"
                aria-live="polite"
              >
                {flowStatus}
              </div>
            )}

            <div className="lit-pin-instrucitons" id="pin-instructions">
              {!hasResendEmailwithPinCode ? (
                <p>
                  Gib die <b>PIN</b> ein, um den Test zu starten. 
                  Falls Du keine PIN erhalten hast, kannst Du ihn an{" "}
                  <b>{targetEmail || "die registrierte Adresse"}</b> senden.
                </p>
              ) : (
                <p>Geben Sie den <b>PIN</b> ein, um den Test zu starten.</p>
              )}
            </div>

            <form
              className="register-form"
              onSubmit={(e) => {
                e.preventDefault();
                this.initCustomLogin();
              }}
            >
              <div className="lit-customPin-form-wrapper">
                <div className="lit-customPIn-inner-content">
                  <div className="lit-compound-pin-fields">
                    <div className="lit-label-pin">
                      <label className="customLogin-pin-lbl" htmlFor="pin-kode">
                        PIN:
                      </label>
                      <input
                        ref={this.pinRef}
                        required
                        name="pin"
                        id="pin-kode"
                        className={`customLogin-pin-tf${pinError ? " is-error" : ""}`}
                        placeholder="hier eingeben"
                        aria-label="PIN-Code, 4 Zeichen"
                        aria-describedby="pin-instructions"
                        autoComplete="one-time-code"
                        inputMode="text"
                        maxLength={4}
                        onChange={this.handleUpdateTestUserEvent}
                        type="text"
                        value={testUser.pin ?? ""}
                      />
                    </div>
                  </div>
                </div>

                <div className="lit-pincode-inlogg">
                  <div className="lit-btn-submit-wrapper">
                    <button className="lit-btn-submit" style={{ color: "white" }}>
                      Test starten
                    </button>
                  </div>

                  {targetEmail && (
                    <div className="lit-btn-submit-wrapper">
                      <button
                        className={
                          testUser.pin ? "lit-btn-submit-pin__disabled" : "lit-btn-submit-pin"
                        }
                        disabled={Boolean(testUser.pin) || !canResend}
                        onClick={(e) => {
                          e.preventDefault();
                          this.sendPinToUserEmailAddress(targetEmail);
                        }}
                      >
                        {canResend
                          ? "PIN senden"
                          : `Erneut senden in ${secondsLeft}s`}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomLogin;
